import { render, staticRenderFns } from "./newTrasladoEngorde.vue?vue&type=template&id=2897ad5a"
import script from "./newTrasladoEngorde.vue?vue&type=script&lang=js"
export * from "./newTrasladoEngorde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports